import type { PropsWithChildren } from 'react';

import { FullPageContent } from '@/components/layout/full-page-content';

export type ShellProps = PropsWithChildren<{ testId?: string }>;

export function Shell({ children, testId }: ShellProps) {
  return (
    <FullPageContent scrollable testId={testId}>
      <div className="mx-auto max-w-screen-2xl space-y-8 px-4 py-8 sm:px-6 lg:px-8">
        {children}
      </div>
    </FullPageContent>
  );
}
